import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaTimes, FaStar, FaCheckCircle } from 'react-icons/fa';

const ChangelogModal = () => {
  const [changelog, setChangelog] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    checkForNewChangelog();
  }, []);

  const checkForNewChangelog = async () => {
    try {
      const { data } = await axios.get('/api/changelog/latest');

      if (!data) return;

      const lastSeenVersion = localStorage.getItem('lastSeenChangelogVersion');

      // Yeni versiyon varsa göster
      if (lastSeenVersion !== data.version) {
        setChangelog(data);
        setIsVisible(true);
      }
    } catch (error) {
      console.error('Changelog kontrol hatası:', error);
    }
  };

  const handleClose = () => {
    if (!isVisible) return;
    setIsClosing(true);
    setTimeout(() => {
      if (changelog) {
        localStorage.setItem('lastSeenChangelogVersion', changelog.version);
      }
      setIsVisible(false);
      setIsClosing(false);
    }, 300); // Wait for animation
  };

  if (!isVisible || !changelog) return null;

  return (
    <div className={`fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4 ${isClosing ? 'animate-fadeOut' : 'animate-fadeIn'}`}>
      <div className={`bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-lg w-full flex flex-col max-h-[85vh] ${isClosing ? 'animate-slideDown' : 'animate-slideUp'}`}>
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-6 text-white relative flex-shrink-0">
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors p-2"
            aria-label="Kapat"
          >
            <FaTimes className="text-xl" />
          </button>

          <div className="flex items-center space-x-3 mb-2">
            <div className="bg-white/20 p-2 rounded-lg">
              <FaStar className="text-2xl" />
            </div>
            <span className="bg-white/20 px-3 py-1 rounded-full text-sm font-medium">
              {changelog.version}
            </span>
          </div>

          <h2 className="text-2xl font-bold">{changelog.title}</h2>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto custom-scrollbar">
          <div className="text-gray-700 dark:text-gray-300 leading-relaxed whitespace-pre-wrap text-sm sm:text-base">
            {changelog.description}
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 pb-6 flex-shrink-0 pt-2">
          <button
            onClick={handleClose}
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold py-3 px-6 rounded-xl flex items-center justify-center space-x-2 transition-all shadow-lg hover:shadow-xl"
          >
            <FaCheckCircle />
            <span>Anladım</span>
          </button>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes fadeOut {
          from { opacity: 1; }
          to { opacity: 0; }
        }
        @keyframes slideUp {
          from { 
            opacity: 0;
            transform: translateY(20px) scale(0.98);
          }
          to { 
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
        @keyframes slideDown {
          from {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          to {
            opacity: 0;
            transform: translateY(20px) scale(0.95);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out forwards;
        }
        .animate-fadeOut {
          animation: fadeOut 0.3s ease-in forwards;
        }
        .animate-slideUp {
          animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        .animate-slideDown {
          animation: slideDown 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
      `}</style>
    </div>
  );
};

export default ChangelogModal;
